import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@razz-team/ui-web';

export function NavItem({
  title,
  icon,
  ...props
}: {
  title: string;
  icon: React.ReactNode;
  href?: string;
  onClick?: () => void;
}) {
  return (
    <ListItem sx={{ color: 'text.secondary', mt: 2 }} disablePadding>
      <ListItemButton {...props} sx={{ borderRadius: 2, padding: { xs: 3, sm: 3, md: 2 } }}>
        <ListItemIcon sx={{ color: 'text.secondary' }}>{icon}</ListItemIcon>
        <ListItemText primary={title} />
      </ListItemButton>
    </ListItem>
  );
}
